import React from 'react';
import {connect} from "react-redux";
import DateDisplay from "../../Boilerplate/DateDisplay";
import {Button, Card, Col, Row} from "antd";
import {CodeTag} from "../../Boilerplate/CodeTag";
import UserSmall from "../../Boilerplate/UserSmall";
import {compose} from "redux";
import {canUpdate} from "../../Boilerplate/permissions";
import {PunchListFiles} from "./PunchListFiles";
import ChatWall from "../../Boilerplate/ChatWall";
import {compArr} from "../selectors";

const PunchListDetail = ({ item, projectId, onEdit }) => {
  const rowWidth = 24;
  const keyWidth = 11;
  const valWidth = rowWidth - keyWidth;
  return (
    <Row gutter={24}>
      <Col span={17}>
        <Card
          className='bid-dashboard-info'
          title={`Punch List #${item.resource.number} - ${item.resource.name}`}
          extra={
            <Button.Group>
              <Button onClick={onEdit} disabled={!canUpdate(item)}>Edit</Button>
            </Button.Group>
          }
        >
          <Row>
            <Col span={12}>
              <Row className='key-value'>
                <Col span={keyWidth}>Assigned To</Col>
                <Col span={valWidth}><UserSmall id={item.resource.owneruserid}/></Col>
              </Row>
              <Row className='key-value'>
                <Col span={keyWidth}>Due</Col>
                <Col span={valWidth}><DateDisplay date={item.resource.duedate}/></Col>
              </Row>
              <Row className='key-value'>
                <Col span={keyWidth}>Priority</Col>
                <Col span={valWidth}><CodeTag table='punchlistitempriority' code={item.resource.priority}/></Col>
              </Row>
              <Row className='key-value'>
                <Col span={keyWidth}>Status</Col>
                <Col span={valWidth}><CodeTag table='punchlistitemstatus' code={item.resource.status}/></Col>
              </Row>
            </Col>
          </Row>
          <p className='formatted-text'>
            {item.resource.description}
          </p>
        </Card>
        <PunchListFiles/>
      </Col>
      <Col span={7}>
        <ChatWall projectId={projectId} punchId={item.resource.id}/>
        {/*<Activity/>*/}
      </Col>
    </Row>
  );
};

export default compose(
  connect(
    (state, props) => {
      let projectId = props.match.params.id;
      let item = state.view.subview.data[props.match.params.punchListId];
      const loading = state.view.subview.cache.loading;
      const path = state.view.path;
      const itempath = ['projects', props.match.params.id, 'punches', props.match.params.punchListId];
      if (!compArr(path, itempath) || loading || !item) return { loading: true };
      return { item, projectId };
    },
    (dispatch, props) => ({
      onEdit: () => props.history.push(`/projects/${props.match.params.id}/punch-list/${props.match.params.punchListId}/edit`)
    })
  ),
)(PunchListDetail);



// WEBPACK FOOTER //
// ./src/components/Projects/PunchList/PunchListDetail.js